import { render, staticRenderFns } from "./SvgVectorUp.vue?vue&type=template&id=56b99574&"
import script from "./SvgVectorUp.vue?vue&type=script&lang=js&"
export * from "./SvgVectorUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports